export const i18n = {
    timelineNav: {
        Today: 'Today',
        Minutes: 'Minutes',
        Hours: 'Hours',
        Days: 'Days',
        Weeks: 'Weeks',
        Months: 'Months',
        Years: 'Years',
    },
    months: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
    ],
};
